import { ROUTE_COMMERCIAL_LINES_SERVICES } from '../../constants/routes';

const handleBackOnClick = (history) => {
  history.push(ROUTE_COMMERCIAL_LINES_SERVICES);
};

export { handleBackOnClick };
